import React from 'react';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { FormField } from '../../redux/types';
import LabelledToggleField from '../base/LabelledToggleField';
import { sanitizeHref } from '@wix/da-url';

import s from './AllowResaleToggle.scss';

interface Props {}

const AllowResaleToggle: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <LabelledToggleField
      name={FormField.AllowResale}
      size="small"
      label={t('sellerModal.create.allow_resale.label')}
      subLabel={t('sellerModal.create.allow_resale.sublabel', {
        postProcess: ['reactPostprocessor', 'featureBrancher'],
        learnMoreLink: (
          <PlainButtonOrLink
            className={s['link']}
            href={sanitizeHref(t('sellerModal.create.allow_resale.sublabel.link.url'))}
          >
            {t('sellerModal.create.allow_resale.sublabel.link.text')}
          </PlainButtonOrLink>
        ),
      })}
      onChange={() => {}}
    />
  );
};

AllowResaleToggle.displayName = 'AllowResaleToggle';

export default AllowResaleToggle;
